import { features, featuresMarkedAsExperimental } from '@/config/features'
import { RemoteFlag } from '@/config/utils'
import { z } from 'zod'

export const featureSchema = z.boolean()

export const experimentalFeatures = featuresMarkedAsExperimental
export type ExperimentalFeature = (typeof featuresMarkedAsExperimental)[number]
export type ExperimentalFeatureStatus = z.infer<typeof featureSchema>

export const IS_IN_MAINTENANCE_KEY = 'IS_IN_MAINTENANCE' as const

export const remoteConfigs = [
  RemoteFlag(
    'obscuredProfileCta',
    z.object({
      title: z.string(),
      content: z.string(),
      buttonText: z.string(),
    }),
    {
      title: 'See their true potential',
      content: 'Unlock the full potential of Advanced Analytics with a DUPR+ subscription.',
      buttonText: 'Start your free trial',
    }
  ),

  RemoteFlag(IS_IN_MAINTENANCE_KEY, z.boolean(), false),

  // Feature flags
  ...features.map((flag) =>
    RemoteFlag(flag, featureSchema, featuresMarkedAsExperimental.includes(flag) ? false : true)
  ),
] as const
